import { Dispatch, SetStateAction, useState } from 'react';
import { CancelButton } from '../../UtilitiesComponents/CancelButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface Props {
    setShowModal: Dispatch<SetStateAction<boolean>>;
    dealName: string;
    upadateDeal: (eliminarVendedores: boolean) => Promise<void>;
}

export function ConfirmarCancelacion({ setShowModal, dealName, upadateDeal }: Props) {
    const [eliminarVendedores, setEliminarVendedores] = useState(false);

    return (
        <div className="bg-white w-[450px] rounded">

            <div className="flex justify-end bg-gray-100 rounded">
                <button onClick={() => setShowModal(false)}>
                    <CloseRoundedIcon  />
                </button>
            </div>

            <div className="p-3">
                <p className="text-xl text-center">¿Esta seguro que quiere cancelar la campaña de {dealName}?</p>

                <div className="flex justify-center my-2 gap-x-1">
                    <input
                        type="checkbox"
                        onChange={(event) => setEliminarVendedores(event.target.checked)}/>
                    <label>Eliminar los vendedors asignados a esta campaña</label>
                </div>

                <div className="flex justify-center pt-4 gap-x-4">
                    <button
                        onClick={() => upadateDeal(eliminarVendedores)}
                        className="bg-red-400 border-2 border-red-500 px-1 py-[2px] rounded-[3px] hover:bg-red-500">
                        <p className="text-sm font-semibold text-white">Cancelar campaña</p>
                    </button>

                    <CancelButton
                        onClick={()=> {
                            setShowModal(false);
                        }}/>
                </div>
            </div>

        </div>
    );
}